interface FooterReturn {
  currentYear: number
}

export const useFooter = (): FooterReturn => {
  const currentYear = new Date().getFullYear()

  return {
    currentYear,
  }
}